import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  notification,
  Select,
  DatePicker,
} from "antd";
import axios from "axios";

const { Option } = Select;

const CreateGroup = (props) => {
  const { setDrawerVisibility, setRefetch, rowData } = props;
  const [btnLoading, setBtnLoading] = useState(false);

  const handleGroupCreate = (values) => {
    const { name, groupAdminName, groupAdminPhone } = values;
    setBtnLoading(true);
    let formData = new FormData();
    formData.append("Name", name);
    formData.append("GroupAdminName", groupAdminName);
    formData.append("GroupAdminPhone", groupAdminPhone);
    if (rowData) {
      formData.append("Id", rowData.id);
    }
    axios(rowData ? "/api/Group/UpdateGroup" : "/api/Group/AddGroup", {
      method: "POST",
      data: formData,
    })
      .then((response) => {
        setBtnLoading(false);
        notification["success"]({
          message: "Success",
          description:  `Group ${rowData ? "Updated" : "Created"} Successfully!`,
        });
        setDrawerVisibility(false);
        setRefetch((prev) => !prev);
      })
      .catch((err) => {
        setBtnLoading(false);
        notification.error({
          message: "Error",
          description: "Unable to Create Group!",
        });
        console.log(err);
      });
  };

  let initialValues = {
    name: rowData && rowData.name,
    groupAdminName: rowData && rowData.groupAdminName,
    groupAdminPhone: rowData && rowData.groupAdminPhone,
  };

  return (
    <Form
      onFinish={handleGroupCreate}
      requiredMark={false}
      initialValues={initialValues}
    >
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "Please input name!" }]}
            name="name"
            label="Name"
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="groupAdminName"
            label="Admin Name"
            labelCol={{ span: 24 }}
            rules={[{ required: true, message: "Please input admin name" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Form.Item
            name="groupAdminPhone"
            label="Admin Phone"
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Please input admin phone number!",
              },
              { max: 10, message: "Phone number must be of 10 digits." },
              { min: 10, message: "" },
              {
                pattern: /^[0-9]*$/,
                message: "Please input a valid phone number!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={btnLoading}>
          {rowData ? "Save" : "Create"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CreateGroup;
